import type { IBid } from '@/services/types/bids/bids';
import type { IQuote } from '@/services/types/core/quotes';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from '../apiRequest';

export const createBidMatchQuote = async (
  bid: Pick<IBid, 'from' | 'to' | 'travelers' | 'pet_friendly'>,
  rentalId: number,
  currency: string,
): Promise<IQuote> => {
  const url = `${getCoreApi()}/quotes`;
  const quote = await apiRequest<IQuote>(
    {
      url,
      method: 'POST',
      data: {
        rental_id: rentalId,
        from: bid.from,
        to: bid.to,
        presentment_currency: currency,
        services: [0],
        trip_credits_disabled: true,
        reserve: true,
        ...(bid.travelers ? { travelers: bid.travelers } : {}),
        ...(bid.pet_friendly ? { pet_friendly: true } : {}),
      },
    },
    true,
  );

  // The API can answer 200 with an empty id, and checkout can't build a booking without one
  if (!quote?.id) {
    throw new Error('Quote was created without an id');
  }

  return quote;
};
